import { Component, OnInit } from '@angular/core';
import { HeaderStyleTwoComponent } from '../header-style-two/header-style-two.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { FeedbackStyleTwoComponent } from '../feedback-style-two/feedback-style-two.component';
import { FunfactsComponent } from '../funfacts/funfacts.component';
import { OurMissionComponent } from '../our-mission/our-mission.component';
import { OurStoryComponent } from '../our-story/our-story.component';
import { OurValuesComponent } from '../our-values/our-values.component';
import { PartnerStyleOneComponent } from '../partner-style-one/partner-style-one.component';
import { NewsService } from 'src/app/services/news.service';
import { environment } from 'src/environments/environment';
import { PublicNewsService } from 'src/app/services/public-news.service';

@Component({
    selector: 'app-public-news-details',
    templateUrl: './public-news-details.component.html',
})
export class PublicNewsDetailsComponent implements OnInit {

    isToggled = false;
    id: string;
    constructor(
        public themeService: ThemeCustomizerService,
        private activateRoute: ActivatedRoute,
        private service: PublicNewsService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.activateRoute.params.subscribe((p) => {
            this.id = p['id'];
            this.ngOnInit();
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void {
        this.getData()
    }
    models: any[] = []
    model: any;
    isLoading: boolean;  

    getData() {
        this.service.getById$(this.id).subscribe(x => {
            this.model = x;
            this.isLoading = true;

            this.generateTagCloud(this.model.keyWord);
        });
        this.service.getAll$().subscribe(x => {
            this.models = x.filter(h => h.referenceId != this.id);
            this.isLoading=true

        })
    }
    createImgPath = (serverPath: string) => {
        if (serverPath)
            return `${environment.patchUrl}/${serverPath}`;
    }
    tagCloud: { keyword: string, count: number }[] = [];

    generateTagCloud(keywordsString: string) {
        // Split the keywords by comma
        const keywordsArray = keywordsString.split(',');

        // Create a map to count occurrences
        const keywordMap = new Map<string, number>();

        keywordsArray.forEach(keyword => {
            if (keywordMap.has(keyword)) {
                keywordMap.set(keyword, keywordMap.get(keyword)! + 1);
            } else {
                keywordMap.set(keyword, 1);
            }
        });

        // Convert the map to an array of objects for rendering
        this.tagCloud = Array.from(keywordMap, ([keyword, count]) => ({ keyword, count }));
    }
}